import http from "./http";

//轮播图列表
function bannerList(number = 5) {
    let url = `/api/weChat/applet/course/banner/list?number=${number}`;
    return http.get(url)
}

//根据课程类型获取列表/weChat/applet/course/list/type
// type	T文本	    是     类型free免费，boutique精品课程
// pageNum	T文本	是    页码
// pageSize	T文本	是    每页容量
function courseTypeList(type, pageNumber = 1, pageSize = 5) {
    let url = `/api/weChat/applet/course/list/type?pageSize=${pageSize}&pageNum=${pageNumber}`;
    const formdata = new FormData();
    formdata.append("type", type);

    return http.post(url, formdata)
}

// 获取专题列表/weChat/applet/subject/list
function subjectList(enable) {
    let url = `/api/weChat/applet/subject/list`;

    return http.post(url, {
        "enable": enable
    })
}

//课程搜索2.0      /pc/course/search/keyword/{keyword}
function search(condition, pageNum = 1, pageSize = 5) {
    let url = `/api/pc/course/search/keyword`;
    if (condition.subjectId == -1) {
        delete condition.subjectId;
    }
    if (condition.courseType == "") {
        delete condition.courseType;
    }
    return http.get(url, {
        params: {
            ...condition,
            pageNum,
            pageSize
        }
    })
}

//获取学员专属课程   /pc/course/courseListForStudent
function courseListForStudent(type, pageNumber = 1, pageSize = 5) {
    let url = `/api/pc/course/courseListForStudent?pageSize=${pageSize}&pageNum=${pageNumber}`;

    return http.post(url, {})
}

const getCourseTopList = () => http.get('/api/best-selling/course/list',)

export {
    bannerList, courseTypeList, subjectList, search, courseListForStudent, getCourseTopList
}

